import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContractDelete20 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_255_5460",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_255_5460)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.8333 16.1878L14.0625 17.9378L12.8958 16.7712L14.6458 15.0003L12.8958 13.2295L14.0625 12.0628L15.8333 13.8128L17.6042 12.0628L18.7708 13.2295L17.0208 15.0003L18.7708 16.7712L17.6042 17.9378L15.8333 16.1878ZM5 18.3337C4.30556 18.3337 3.71528 18.0906 3.22917 17.6045C2.74306 17.1184 2.5 16.5281 2.5 15.8337V13.3337H5V1.66699H17.5V10.3128C17.2361 10.2156 16.9653 10.1427 16.6875 10.0941C16.4097 10.0455 16.125 10.0212 15.8333 10.0212V3.33366H6.66667V13.3337H11.125C11.0278 13.5975 10.9549 13.8684 10.9062 14.1462C10.8576 14.4239 10.8333 14.7087 10.8333 15.0003H4.16667V15.8337C4.16667 16.0698 4.24653 16.2677 4.40625 16.4274C4.56597 16.5871 4.76389 16.667 5 16.667H11.125C11.2361 16.9864 11.375 17.285 11.5417 17.5628C11.7083 17.8406 11.9028 18.0975 12.125 18.3337H5ZM7.5 7.50033V5.83366H15V7.50033H7.5ZM7.5 10.0003V8.33366H15V10.0003H7.5Z",
				fill: "#EF476F"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgContractDelete20);
export { ForwardRef as ReactComponent };
